module.exports = __webpack_public_path__ + "static/media/vf_mshoes_core.90109eab.svg";